export class ClickedDeviceInfo {

    constructor(deviceId: string) {
        this.deviceId = deviceId;
    }

    deviceId: string;
    deviceDataSheetId?: number;
    logicSolverSheetId?: number;
    supportSheetId?: number;

    isDevice() {
        return this.deviceId != null && this.deviceDataSheetId != null;
    }

    isLogicSolver() {
        return this.deviceId != null && this.logicSolverSheetId != null;
    }

    isSupportSystem() {
        return this.deviceId != null && this.supportSheetId != null;
    }
}